import "./App.css";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Toaster } from "react-hot-toast";
import Login from "./pages/auth/Login";
import Dashboard from "./pages/dashboard";

import Products from "./pages/catalog/products";
import Services from "./pages/services";
import Orders from "./pages/sales/orders";
import Coupons from "./pages/customers/coupons";
import ProtectedRoutes from "./routes/ProtectedRoutes";
import Reports from "./pages/reports";
import Blogs from "./pages/blogs";
import AddProduct from "./pages/catalog/products/AddProduct";
import Taxes from "./pages/taxes";
import Brands from "./pages/brands";
import Frames from "./pages/frames";
import EditProduct from "./pages/catalog/products/EditProduct";
import Lens from "./pages/lens";
import LensSize from "./pages/lensSize";
import LenSizeMapping from "./pages/lensSizeMapping";
import Layout from "./components/layout/index";
import SalesRoute from "./routes/SalesRoute";
import ScrollTop from "./routes/ScrollTop";
import Customers from "./pages/customers/customersList";
import "react-datepicker/dist/react-datepicker.css";
import Category from "./pages/category";
import { SingleProduct } from "./pages/catalog/products/SingleProduct";
import ProductUpload from "./pages/productupload";
import NewEditProduct from "./pages/catalog/products/NewEditProduct";
import Testimonials from "./pages/catalog/testimonials";
import PitchDeck from "./pages/catalog/pitchdeck";

const queryClient = new QueryClient();
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      <Router>
        <ScrollTop />
        <Routes>
          <Route path="/login" exact element={<Login />} />
          <Route path="/" exact element={<Login />} />
          <Route element={<ProtectedRoutes />}>
            <Route element={<Layout />}>
              <Route path="dashboard" element={<Dashboard />} />
              {/* <Route path="sales/orders" exact element={<Orders />} /> */}
              {/* <Route path="sales/invoices" exact element={<Dashboard />} /> */}
              {/* <Route path="sales/returns" exact element={<Dashboard />} /> */}
              <Route path="catalog/category" exact element={<Category />} />
              <Route path="catalog/products" exact element={<Products />} />
              <Route
                path="catalog/products/add-product"
                exact
                element={<AddProduct />}
              />
              <Route
                path="catalog/products/edit-product/:id"
                exact
                element={<NewEditProduct />}
              />
              {/* <Route
                path="catalog/product-uploads"
                exact
                element={<ProductUpload />}
              /> */}
              <Route
                path="catalog/products/single-product-pricing/:id"
                exact
                element={<SingleProduct />}
              />
              {/* <Route path="customers/coupons" exact element={<Coupons />} />
              <Route
                path="customers/all-customers"
                exact
                element={<Customers />}
              /> */}
              <Route path="system/blogs" exact element={<Blogs />} />
              <Route
                path="catalog/testimonials"
                exact
                element={<Testimonials />}
              />
              <Route path="catalog/pitchdeck" exact element={<PitchDeck />} />
            </Route>
          </Route>
        </Routes>
      </Router>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
